{
  "familyId": "SPR-KLANK-BAKKER",
  "questions": [
    {
      "id": "SPR-KLANK-BAKKER-001",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "multiple_choice",
      "question": "Iemand die bakt, is een ...",
      "options": ["bakker", "baker", "bakkker", "baakker"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "bakker",
            "syllables": ["bak", "ker"],
            "types": ["closed", "closed"],
            "label": "bak·ker — twee gesloten lettergrepen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De bakker-regel",
            "content": "Hoor je een korte klank (a, e, i, o, u) in een gesloten lettergreep? Dan verdubbel je de medeklinker erachter. Zo blijft de klank kort: bak → bak-ker (niet ba-ker, want dan wordt de 'a' lang).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bakker_regel_kk",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het woord 'bakker' heeft een korte 'a'. Als je de lettergrepen splitst, krijg je bak-ker. De 'k' wordt verdubbeld zodat de eerste lettergreep gesloten blijft en de 'a' kort klinkt. Schrijf je 'baker', dan lees je ba-ker met een lange 'a' — en dat is een ander woord!",
        "solutionSteps": [
          "Luister naar de klinker: de 'a' in 'bak' is kort",
          "Een korte klinker staat in een gesloten lettergreep (eindigt op een medeklinker)",
          "Verdubbel de medeklinker: bak → bak-ker",
          "Check: bak-ker — de 'a' blijft kort ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! De korte 'a' in 'bak' zorgt ervoor dat de 'k' verdubbeld wordt: bak-ker.",
          "1": "Je dacht waarschijnlijk dat één 'k' genoeg is. Maar 'baker' lees je als ba-ker, met een lange 'a'. De dubbele 'k' houdt de lettergreep gesloten: bak-ker. Onthoud: korte klank → dubbele medeklinker.",
          "2": "Je dacht waarschijnlijk dat je drie k's schrijft. Maar in het Nederlands verdubbel je een medeklinker, je verdrievoudigt hem niet. Eén 'k' erbij is genoeg: bak-ker.",
          "3": "Je dacht waarschijnlijk dat de klinker verdubbeld moet worden. Maar 'aa' maakt de klank juist lang. Bij de bakker-regel verdubbel je de medeklinker, niet de klinker: bak-ker."
        }
      }
    },
    {
      "id": "SPR-KLANK-BAKKER-002",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "multiple_choice",
      "question": "De zwemmer traint elke dag. Welke spelling is goed?",
      "options": ["zwemmer", "zwemer", "zwemmmer", "zweemer"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "zwemmer",
            "syllables": ["zwem", "mer"],
            "types": ["closed", "closed"],
            "label": "zwem·mer — twee gesloten lettergrepen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De bakker-regel",
            "content": "Hoor je een korte klank? Verdubbel de medeklinker erachter. Zwem heeft een korte 'e', dus: zwem-mer (niet zwe-mer, want dan wordt de 'e' lang).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bakker_regel_mm",
      "variantIndex": 2,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Het woord 'zwemmer' heeft een korte 'e'. De 'm' wordt verdubbeld zodat de lettergreep gesloten blijft: zwem-mer. Schrijf je 'zwemer', dan lees je zwe-mer met een lange 'e' — en dat klinkt verkeerd.",
        "solutionSteps": [
          "Luister naar de klinker: de 'e' in 'zwem' is kort",
          "Korte klinker → gesloten lettergreep nodig",
          "Verdubbel de medeklinker: zwem → zwem-mer",
          "Check: zwem-mer — de 'e' blijft kort ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! De korte 'e' in 'zwem' zorgt voor een dubbele 'm': zwem-mer.",
          "1": "Je dacht waarschijnlijk dat één 'm' genoeg is. Maar 'zwemer' lees je als zwe-mer, met een lange 'e'. De dubbele 'm' houdt de klank kort: zwem-mer. Onthoud: korte klank → dubbele medeklinker.",
          "2": "Je dacht waarschijnlijk dat je drie m's schrijft. Maar je verdubbelt een medeklinker, je verdrievoudigt hem niet. Eén 'm' erbij is genoeg: zwem-mer.",
          "3": "Je dacht waarschijnlijk dat de klinker verdubbeld moet worden. Maar 'ee' maakt de klank lang. Bij de bakker-regel verdubbel je de medeklinker: zwem-mer."
        }
      }
    },
    {
      "id": "SPR-KLANK-BAKKER-003",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "multiple_choice",
      "question": "We gaan morgen hard ... (rennen). Welke spelling is goed?",
      "options": ["rennen", "renen", "rennnen", "reenen"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "rennen",
            "syllables": ["ren", "nen"],
            "types": ["closed", "closed"],
            "label": "ren·nen — twee gesloten lettergrepen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De bakker-regel bij werkwoorden",
            "content": "Ook bij werkwoorden geldt de bakker-regel. 'Ren' heeft een korte 'e', dus het hele werkwoord is ren-nen. De 'n' wordt verdubbeld om de korte klank te bewaren.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bakker_regel_nn_werkwoord",
      "variantIndex": 3,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Het werkwoord 'rennen' heeft een korte 'e'. De 'n' wordt verdubbeld: ren-nen. Zo blijft de eerste lettergreep gesloten en de 'e' kort. Schrijf je 'renen', dan lees je re-nen met een lange 'e'.",
        "solutionSteps": [
          "Luister naar de klinker: de 'e' in 'ren' is kort",
          "Korte klinker → gesloten lettergreep nodig",
          "Verdubbel de medeklinker: ren → ren-nen",
          "Check: ren-nen — de 'e' blijft kort ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! De korte 'e' in 'ren' zorgt voor een dubbele 'n': ren-nen.",
          "1": "Je dacht waarschijnlijk dat één 'n' genoeg is. Maar 'renen' lees je als re-nen, met een lange 'e'. De dubbele 'n' houdt de klank kort: ren-nen. Onthoud: korte klank → dubbele medeklinker.",
          "2": "Je dacht waarschijnlijk dat je drie n's schrijft. Maar je verdubbelt een medeklinker, nooit meer. Eén 'n' erbij is genoeg: ren-nen.",
          "3": "Je dacht waarschijnlijk dat de klinker verdubbeld moet worden. Maar 'ee' maakt de klank lang (renen → re-nen). Bij de bakker-regel verdubbel je de medeklinker: ren-nen."
        }
      }
    },
    {
      "id": "SPR-KLANK-BAKKER-004",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "multiple_choice",
      "question": "De kat zit op de stoel. Ze is lekker aan het ... (zitten).",
      "options": ["zitten", "ziten", "zittten", "zieten"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "zitten",
            "syllables": ["zit", "ten"],
            "types": ["closed", "closed"],
            "label": "zit·ten — twee gesloten lettergrepen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De bakker-regel bij werkwoorden",
            "content": "Het werkwoord 'zitten' heeft een korte 'i'. De 't' wordt verdubbeld: zit-ten. Zo blijft de lettergreep gesloten en de 'i' kort.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bakker_regel_tt_werkwoord",
      "variantIndex": 4,
      "citoDifficulty": 0.24,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Het werkwoord 'zitten' heeft een korte 'i'. De 't' wordt verdubbeld: zit-ten. Schrijf je 'ziten', dan lees je zi-ten met een lange 'i' — en dat klinkt als 'zijten'.",
        "solutionSteps": [
          "Luister naar de klinker: de 'i' in 'zit' is kort",
          "Korte klinker → gesloten lettergreep nodig",
          "Verdubbel de medeklinker: zit → zit-ten",
          "Check: zit-ten — de 'i' blijft kort ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! De korte 'i' in 'zit' zorgt voor een dubbele 't': zit-ten.",
          "1": "Je dacht waarschijnlijk dat één 't' genoeg is. Maar 'ziten' lees je als zi-ten, met een lange 'i'. De dubbele 't' houdt de klank kort: zit-ten. Onthoud: korte klank → dubbele medeklinker.",
          "2": "Je dacht waarschijnlijk dat je drie t's schrijft. Maar je verdubbelt een medeklinker, nooit meer. Eén 't' erbij is genoeg: zit-ten.",
          "3": "Je dacht waarschijnlijk dat de klinker verandert. Maar 'ie' is een andere klank dan 'i'. Bij de bakker-regel verdubbel je de medeklinker, niet de klinker: zit-ten."
        }
      }
    },
    {
      "id": "SPR-KLANK-BAKKER-005",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "multiple_choice",
      "question": "Welk woord is goed geschreven?",
      "options": ["botteren", "boteren", "bottteren", "booteren"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "botteren",
            "syllables": ["bot", "te", "ren"],
            "types": ["closed", "open", "closed"],
            "label": "bot·te·ren — de eerste lettergreep is gesloten"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De bakker-regel herkennen",
            "content": "Kijk naar de eerste lettergreep. Is de klinker kort? Dan moet de lettergreep gesloten zijn (eindigen op een medeklinker). Verdubbel de medeklinker om dat te bereiken: bot → bot-te-ren.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bakker_regel_tt_herkennen",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Het woord 'botteren' heeft een korte 'o' in de eerste lettergreep. De 't' wordt verdubbeld: bot-te-ren. Schrijf je 'boteren', dan lees je bo-te-ren met een lange 'o' — en dat klinkt als 'booteren'.",
        "solutionSteps": [
          "Luister naar de klinker: de 'o' in 'bot' is kort",
          "Korte klinker → gesloten lettergreep nodig",
          "Verdubbel de medeklinker: bot → bot-te-ren",
          "Check: bot-te-ren — de 'o' blijft kort ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! De korte 'o' in 'bot' zorgt voor een dubbele 't': bot-te-ren.",
          "1": "Je dacht waarschijnlijk dat één 't' genoeg is. Maar 'boteren' lees je als bo-te-ren, met een lange 'o'. De dubbele 't' houdt de klank kort: bot-te-ren. Onthoud: korte klank → dubbele medeklinker.",
          "2": "Je dacht waarschijnlijk dat je drie t's schrijft. Maar je verdubbelt een medeklinker, nooit meer. Eén 't' erbij is genoeg: bot-te-ren.",
          "3": "Je dacht waarschijnlijk dat de klinker verdubbeld moet worden. Maar 'oo' maakt de klank lang. Bij de bakker-regel verdubbel je de medeklinker: bot-te-ren."
        }
      }
    },
    {
      "id": "SPR-KLANK-BAKKER-006",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "M6-",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "multiple_choice",
      "question": "De schilder heeft veel ... (verven) nodig voor het huis. Welke spelling is goed?",
      "options": ["verffen", "verfen", "verfffen", "veerfen"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "verffen",
            "syllables": ["verf", "fen"],
            "types": ["closed", "closed"],
            "label": "verf·fen — let op: de 'f' wordt verdubbeld"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De bakker-regel met 'f'",
            "content": "Ook de 'f' kan verdubbeld worden. 'Verf' heeft een korte 'e', dus bij het vervoegen wordt de 'f' verdubbeld: verf-fen. Zo blijft de 'e' kort.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bakker_regel_ff",
      "variantIndex": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.66,
      "feedback": {
        "explanationText": "Het woord 'verffen' heeft een korte 'e'. De 'f' wordt verdubbeld: verf-fen. Dit is een lastig woord omdat 'verf' al op een 'f' eindigt. Maar de regel is hetzelfde: korte klank → dubbele medeklinker.",
        "solutionSteps": [
          "Luister naar de klinker: de 'e' in 'verf' is kort",
          "Korte klinker → gesloten lettergreep nodig",
          "Verdubbel de laatste medeklinker: verf → verf-fen",
          "Check: verf-fen — de 'e' blijft kort ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! De korte 'e' in 'verf' zorgt voor een dubbele 'f': verf-fen.",
          "1": "Je dacht waarschijnlijk dat één 'f' genoeg is. Maar zonder de dubbele 'f' wordt de lettergreep open en klinkt de 'e' lang. Onthoud: korte klank → dubbele medeklinker.",
          "2": "Je dacht waarschijnlijk dat je drie f's schrijft. Maar je verdubbelt een medeklinker, nooit meer. Eén 'f' erbij is genoeg: verf-fen.",
          "3": "Je dacht waarschijnlijk dat de klinker verdubbeld moet worden. Maar 'ee' maakt de klank lang. Bij de bakker-regel verdubbel je de medeklinker: verf-fen."
        }
      }
    }
  ]
}